export const USER_ROLE = {
  INDIVIDUAL_USER: 'INDIVIDUAL_USER',
  COMPANY_EMPLOYEE: 'COMPANY_EMPLOYEE',
  COMPANY_ADMIN: 'COMPANY_ADMIN',
  NISSHOKEN_ADMIN: 'NISSHOKEN_ADMIN',
  NISSHOKEN_SUPER_ADMIN: 'NISSHOKEN_SUPER_ADMIN'
}
